var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2944 21.0169V23.5286L11.3974 24.2639L12.7698 23.755L13.2356 22.4256L12.5003 21.3227L11.3867 20.5874L10.2944 21.0169Z",
    fill: "#E8F1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7059 21.0169L13.6136 20.5874L12.5 21.3227V23.5286L13.6029 24.2639L14.7059 23.5286C14.7059 22.7296 14.7059 21.8159 14.7059 21.0169Z",
    fill: "#CFDBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35352 23.5288V24.9994H12.5006L13.2359 24.2641L12.5006 23.5288C11.1144 23.5288 8.16102 23.5288 7.35352 23.5288Z",
    fill: "#CFDBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6471 23.5288C16.2609 23.5288 13.3075 23.5288 12.5 23.5288V24.9994H17.6471C17.6471 24.4851 17.6471 24.0431 17.6471 23.5288Z",
    fill: "#B3C7EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35352 5.14706L8.08881 5.88235L7.35352 6.61765V8.08824L8.08881 8.82353L7.35352 9.55882V11.0294L8.08881 11.7647L7.35352 12.5C7.35352 15.338 9.66239 17.6471 12.5006 17.6471L13.2359 8.82353L12.5006 0C9.66254 0 7.35352 2.30887 7.35352 5.14706Z",
    fill: "#4E5F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6471 12.5L16.9118 11.7647L17.6471 11.0294V9.55882L16.9118 8.82353L17.6471 8.08824V6.61765L16.9118 5.88235L17.6471 5.14706C17.6471 2.30902 15.3382 0 12.5 0V17.6471C15.338 17.6471 17.6471 15.3382 17.6471 12.5Z",
    fill: "#3E4665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88221 13.2347C5.88221 12.9775 5.88221 12.7566 5.88221 12.4994H7.3528L8.08809 11.7641L7.3528 11.0288C6.99696 11.0288 4.76981 11.0288 4.41162 11.0288V13.2347C4.41162 17.6944 8.03986 21.3229 12.4999 21.3229L13.2352 20.5876L12.4999 19.8523C8.85093 19.8523 5.88221 16.8838 5.88221 13.2347Z",
    fill: "#CFDBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5882 13.2347C20.5882 12.5003 20.5882 11.7632 20.5882 11.0288C20.2324 11.0288 18.0052 11.0288 17.6471 11.0288L16.9118 11.7641L17.6471 12.4994H19.1176V13.2347C19.1176 16.8836 16.1491 19.8523 12.5 19.8523V21.3229C16.9598 21.3229 20.5882 17.6947 20.5882 13.2347Z",
    fill: "#B3C7EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8535 7.35268H21.3241V2.94092H19.8535V7.35268Z",
    fill: "#6594E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7944 10.2947H24.265C24.265 9.80453 24.265 1.96139 24.265 1.47119H22.7944V10.2947Z",
    fill: "#6594E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14735 8.82436C4.63303 8.82436 4.19107 8.82436 3.67676 8.82436V4.4126H5.14735V8.82436Z",
    fill: "#8BCAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.20594 10.2947C1.69163 10.2947 1.24967 10.2947 0.735352 10.2947V1.47119H2.20594V10.2947Z",
    fill: "#8BCAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7061 6.61707H17.6472C17.6472 6.10276 17.6472 5.6608 17.6472 5.14648C17.2914 5.14648 15.0642 5.14648 14.7061 5.14648V6.61707Z",
    fill: "#2E2F4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7061 9.55799H17.6472C17.6472 9.04368 17.6472 8.60172 17.6472 8.0874C17.2914 8.0874 15.0642 8.0874 14.7061 8.0874V9.55799Z",
    fill: "#2E2F4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7061 12.4994H17.6472C17.6472 11.9851 17.6472 11.5431 17.6472 11.0288C17.2914 11.0288 15.0642 11.0288 14.7061 11.0288V12.4994Z",
    fill: "#2E2F4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2947 6.61707C9.93886 6.61707 7.7117 6.61707 7.35352 6.61707C7.35352 6.10276 7.35352 5.6608 7.35352 5.14648H10.2947V6.61707Z",
    fill: "#3E4665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2947 9.55799C9.93886 9.55799 7.7117 9.55799 7.35352 9.55799C7.35352 9.04368 7.35352 8.60172 7.35352 8.0874H10.2947V9.55799Z",
    fill: "#3E4665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2947 12.4994C9.93886 12.4994 7.7117 12.4994 7.35352 12.4994C7.35352 11.9851 7.35352 11.5431 7.35352 11.0288H10.2947V12.4994Z",
    fill: "#3E4665"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/Mic.8d1675404c9ca072bc4def68d76acda3.svg";
export { ForwardRef as ReactComponent };